import { render, staticRenderFns } from "./ResultH.vue?vue&type=template&id=10bdb3f8&"
import script from "./ResultH.vue?vue&type=script&lang=js&"
export * from "./ResultH.vue?vue&type=script&lang=js&"
import style0 from "./ResultH.vue?vue&type=style&index=0&id=10bdb3f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports